export const mediaQueries = {
    mobile: '320px',
    tablet: '768px',
    underDesktop: '1024px',
    desktop: '1279px'
}
